/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import LocalDate from '../../domain/type/Date'
import MonthlyReportEvent from '../../event/MonthlyReportEvent'

const AccommodationTaxSearchState = Record({
  search_monthly_close_date: LocalDate.today().beginningOfMonth(),
  search_hotel_id: null
})

class AccommodationTaxSearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AccommodationTaxSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyReportEvent.accommodationTaxMonthChanged:
        return state.merge({
          search_monthly_close_date: payload.date,
          search_hotel_id: payload.hotel_id
        })

      case MonthlyReportEvent.onEditAccommodationTaxSearchCondition:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new AccommodationTaxSearchStore()
